import { render, staticRenderFns } from "./WooCommerceIpBlockNoticeCmp.vue?vue&type=template&id=2752c5b3&scoped=true&"
import script from "./WooCommerceIpBlockNoticeCmp.vue?vue&type=script&lang=js&"
export * from "./WooCommerceIpBlockNoticeCmp.vue?vue&type=script&lang=js&"
import style0 from "./WooCommerceIpBlockNoticeCmp.vue?vue&type=style&index=0&id=2752c5b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2752c5b3",
  null
  
)

export default component.exports